import { Box, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import DataClient from "../../../../../../Service/general_data_service";

function ProgramDimensions(props) {
  const [pageData, setPageData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = (params) => {
    DataClient.getData(
      "assignment_details/fetch_coaching_dimension?assignment_id=" +
        props.location.state.currentAssignment.id
    )
      .then((res) => {
        pageData.length = 0;
        setPageData(pageData.concat(res.programme_info_modules));
      })
      .catch((res) => {});
  };

  return (
    <Box my={3}>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12}>
          <Box mt={3}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="flex-start"
            >
              <Grid item xs={3}>
                <Typography variant="h2">
                  <Box textAlign="left" fontWeight="fontWeightBold">
                    Coaching dimensions
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="h2">
                  <Box textAlign="left" fontWeight="fontWeightBold">
                    Description
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h2">
                  <Box textAlign="left" fontWeight="fontWeightBold">
                    Duration
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h2">
                  <Box textAlign="left" fontWeight="fontWeightBold">
                    Attendees
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {pageData.length > 0 &&
            pageData.map((option) => {
              return (
                <Box mt={3}>
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="flex-start"
                  >
                    <Grid item xs={3}>
                      <Typography variant="h2">
                        <Box textAlign="left">{option?.module_name}</Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={5} style={{ paddingRight: "20px" }}>
                      <Typography variant="h2">
                        <Box textAlign="justify">
                          {option?.description || "-"}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="h2">
                        <Box textAlign="left">{option?.duration}</Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="h2">
                        <Box textAlign="left">
                          {option?.attendees.join(", ")}
                        </Box>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
        </Grid>
      </Grid>
    </Box>
  );
}

export default ProgramDimensions;
